type LBGSharedOwnershipCompanyOption {
  label: String!
  value: String!
}

enum NewBuildEPCRating {
  Actual
  Predicted
}

enum DipLBGDebtRepaymentSource {
  Bonus
  DebtConsolidation
  Equity
  Family
  Other
  RegularIncome
  SaleOfAsset
  Saving
}

enum DipLBGStatus {
  NoData
  InProgress
  Accepted
  Declined
  PolicyDecline
  ActionRequired
  AlternativeLending
  DecisionPending
  RedecisionRequired
  DueToExpire
  Expired
  Cancelled
  AcceptedRemortgagePositive
  AcceptedRemortgageNegative
}

type DipLBGDecisionDetailsApplicant {
  applicantNumber: String!
  manualVerificationRequiredAtFma: Boolean!
}

type DipLBGDecisionInformation {
  description: String!
}

type DipLBGDecisionDetails {
  applicants: [DipLBGDecisionDetailsApplicant!]!
  decision: DipLBGStatus!
  information: [DipLBGDecisionInformation!]!
  mortgageId: String!
}

type SubmitLBGDip {
  id: String
  approved_amount: Int
  lender: String
  link: String
  provider: String
  provider_id: String
  reason: String
  status: String
  details: DipLBGDecisionDetails
  available_next_steps: [NextStep!]
  fields: SubmitDipFields
}

input DipLBGSelfEmploymentInput {
  self_employment_income_id: ID!
  gross_profit_in_pence: BigInt!
  net_profit_in_pence: BigInt!
  income_verified: Boolean
}

input DipLBGSourceOfPaymentInput {
  debt_id: ID!
  source_of_payment: String!
}

input DipLBGMortgageSourceOfPaymentInput {
  mortgage_id: ID!
  source_of_payment: String!
}

input DipLBGClientInput {
  basic_income_verified: Boolean
  bonus_income_verified: Boolean
  commission_income_verified: Boolean
  other_income_verified: Boolean
  overtime_income_verified: Boolean
  retirement_income_verified: Boolean
  self_employments: [DipLBGSelfEmploymentInput!]
  source_of_payments: [DipLBGSourceOfPaymentInput!]
  mortgage_source_of_payments: [DipLBGMortgageSourceOfPaymentInput!]
}

input LBGDipInput {
  client: [DipLBGClientInput!]!
  epc_assessment: NewBuildEPCRating
  right_to_buy_cost_of_improvements: Int
  shared_ownership_company_code: String
  bonus_to_be_used_as_repayment_vehicle: Boolean
}

input LbgAuthCreds {
  username: String!
  encrypted_password: String!
  lender: String!
}
